import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersSkillEvaluationTermNewType } from "~/domains";

const request = async (): Promise<ApiManagersSkillEvaluationTermNewType> => {
  const response =
    await new ApiClient().get<ApiManagersSkillEvaluationTermNewType>(
      "/api/managers/skill_evaluation_terms/new",
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersSkillEvaluationTermsNew = ({
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersSkillEvaluationTermNewType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersSkillEvaluationTermsNew"],
    queryFn: () => request(),
  });
};
